import "./WalletSection.css";
import { Wallet, Check } from "lucide-react";
import { usePayment } from "../../../../../context/PaymentContext";

export default function WalletSection(
//     {
//     wallet,
//     summary,
//     useWallet,
//     setUseWallet,
// }
) {

const {
    wallet,
    summary,
    useWallet,
    setUseWallet,
  } = usePayment();
    
    const balance = Number(wallet?.balance || 0);
    const payable = Number(summary?.payable || 0);
    if (balance <= 0) return null;

    const walletAmount = Math.min(balance, payable);
    const onlineAmount = payable - walletAmount;
    // const onlineAmount = payable;

    return (
        <section className="wallet-section">

            <label className="wallet-header">

                <input
                    type="checkbox"
                    checked={useWallet}
                    onChange={(e) =>
                        setUseWallet(e.target.checked)
                    }
                />

                <Wallet size={22} />

                <span>
                    استفاده از موجودی کیف پول
                </span>

            </label>

            <div className="wallet-balance">

                <div className="wallet-row">

                    <span>موجودی کیف پول</span>

                    <strong>
                        {balance.toLocaleString("fa-IR")} تومان
                    </strong>

                </div>

                {useWallet && (

                    <>
                        <div className="wallet-row">

                            <span>پرداخت از کیف پول</span>

                            <strong className="wallet-green">

                                <Check size={16} />

                                {walletAmount.toLocaleString("fa-IR")} تومان

                            </strong>

                        </div>

                        <div className="wallet-row">

                            <span>مانده برای پرداخت آنلاین</span>

                            <strong className="wallet-red">

                                {onlineAmount.toLocaleString("fa-IR")} تومان

                            </strong>

                        </div>
                    </>

                )}

            </div>

        </section>
    );
}